import React from "react";

export type PanelSpinnerProps = {
  className?: string;
  /**
   * Render as a purely visual ring: no role, no label, hidden from assistive
   * tech. Use for the cosmetic open reveal, where nothing is actually loading —
   * announcing "Loading" there would report a fetch that is not happening.
   * Mirrors `decorative` on the `GenericSkeleton` primitives.
   */
  decorative?: boolean;
};

/**
 * The loading ring used inside the rail's overlay panels — the tenant selector's
 * columns and the account card's product list.
 *
 * Shared rather than one per panel so the two cannot drift apart in size or
 * colour; it stays local to the rail rather than moving to `ui-components`
 * because the codebase has no spinner primitive yet and inventing one is a
 * wider change than this ticket.
 */
export default function PanelSpinner({
  className = "",
  decorative = false,
}: PanelSpinnerProps) {
  const a11y = decorative
    ? ({ "aria-hidden": true } as const)
    : ({ role: "status", "aria-label": "Loading" } as const);

  return (
    <span
      {...a11y}
      className={`inline-block shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent text-semantic-text-brand motion-reduce:animate-none ${className}`}
    />
  );
}
